/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <section
    id="home-section"
    class="row"
    aria-labelledby="HomeHeader"
  >
    <div
      class="col-md-10 col-md-offset-1"
      style="margin-bottom: 200px;"
    >
      <h1 id="HomeHeader">
        Want to give the best speech possible?
      </h1>
      <div style="font-size: 16px;">
        <p>
          Upload your speech and have it analyzed.
        </p>
        <p>
          &nbsp;<span style="color:#333;">
            &bull;
          </span>&nbsp; See your "Vibe" score
        </p>
        <p>
          &nbsp;<span style="color:#333;">
            &bull;
          </span>&nbsp; Improve speaking habits
        </p>
        <p>
          &nbsp;<span style="color:#333;">
            &bull;
          </span>&nbsp; Track your progress
        </p>
        <br>
        <router-link
          class="btn btn-primary"
          :to="{ name: 'sign-up' }"
        >
          Get Started Now
        </router-link>
        <br><br><br><br><br><br><br><br><br>
      </div>
    </div>
  </section>
</template>

<style lang="less" scoped>
#HomeHeader {
  font-size: 22px;
  font-weight: bold;
}
#home-section {
  background:
    url(https://voicevibes.s3.amazonaws.com/static/images/waves_divider_full_color.svg) 0px 200px no-repeat,
    url(https://voicevibes.s3.amazonaws.com/static/images/Bigtincan_art.jpg) 0px 130px no-repeat;
  background-size: 100%;
}
</style>

<script>
export default {
  data() {
    return {
      announcement: '',
    };
  },
  created() {
    if (this.$store.getters.isAuthenticated) {
      this.$router.replace({ name: 'subscription' });
    }
  }
};
</script>
